import React from 'react';
import ReactGA from 'react-ga';
import styled from "styled-components";

interface GraphProps {
    step: number;
}

interface InfoGraphInner {
    width: number;
}

const StepGraph:React.SFC<GraphProps> = ({ step}) => {
    let steps = Math.floor( step / 12 * 100 );
    return (
        <StyledGraph>
            <GraphInner width={steps}/>
        </StyledGraph>
    );
};

export default StepGraph;

const StyledGraph = styled.div `
	width: 100%;
	height: 6px;
	margin: 0 0 10px 0;
	border-radius: 2em;
	background-color: #373737;
	float: left;
`
const GraphInner = styled.div `
	width: ${(props:InfoGraphInner) => props.width}%;
	height: 100%;
	margin-bottom: 1em;
	border-radius: 2em;
	background-color: #ffcf24;
	transition: all 0.5s ease-in;
`
